/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';
import moment from 'moment';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  assetStore: Object,
  form: TypeForm,
};

@translate()
@inject('assetStore', 'userStore')
@observer
export default class SelfAuditMultiForm extends React.Component<*> {
  render(): React.Node {
    const { t, asset, form }: TypeProps = this.props;
    const user = this.props.userStore.getActiveUserFromLocal();
    const userName = `${user.first_name} ${user.last_name}`;
    const today = moment().format('DD-MM-YYYY');

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={`${asset && asset.length} ${t(
              'actionDrawer:Asset(s) to be confirmed for audit from selected'
            )}`}
          >
            <div>
              {t(
                `actionDrawer: By confirming the asset audit, the following assets will be marked as audited by ${userName} on ${today}`
              )}
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('actionDrawer:Confirm')} />
      </React.Fragment>
    );
  }
}
